import { FormControl } from "@angular/forms";

/**
 * Allows an empty value (presence is enforced by Validators.required where needed),
 * zero, and positive integers. Rejects negatives and non-integers.
 */
export function nonNegativeIntegerValidator(control: FormControl): { [key: string]: any } | null {
  const raw = control.value;

  if (raw === null || raw === undefined || raw === "") {
    return null;
  }

  const value: number = +raw;

  if (!Number.isInteger(value) || value < 0) {
    return { nonNegativeInteger: true };
  }

  return null;
}
